import { Link } from "react-router-dom";

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-2 text-sm">
      {items.map((item, index) => (
        <span key={index} className="flex items-center gap-2">
          {index > 0 && (
            <span className="text-foreground-400 mx-1">/</span>
          )}
          {item.href ? (
            <Link to={item.href} className="text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800 font-medium whitespace-nowrap">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}